import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import {
  TopNav,
  TopTabs,
  DetailOne,
  ImgBlocks,
  FooterBlock,
  ServiceBlock,
} from "../../component/home";

import { GetCategories } from "../../redux/actions/productAction";
import CollectionTabs from "component/home/CollectionTabs";
import RecentBlog from "component/home/RecentBlogs";
import Testimonials from "component/home/testimonials";
/**
 * Home: The User's home Page of the App
 * @return {JSX.Element} The JSX Code for the Login Page
 */
// import React from 'react'

const Home = () => {
  const ref1 = useRef();
  function scrollTo(ref) {
    if (!ref.current) return;
    ref.current.scrollIntoView({ behavior: "smooth" });
  }
  const [play, setPlay] = useState(false);

  const getVideo = useRef(null);
  const playVideo = () => {
    getVideo.current.play();
  };
  const pauseVideo = () => {
    getVideo.current.pause();
  };
  const videoMuted = () => {
    getVideo.current.muted = true;
  };
  const videoUnMuted = () => {
    getVideo.current.muted = false;
  };

  const [count, setCount] = useState(0);
  function videoPlayer() {
    setCount(count + 1);
    if (count % 2 == 0) {
      playVideo();
      videoUnMuted();
    } else {
      pauseVideo();
      videoMuted();
    }
  }

  return (
    <div>
      <div id="home">
        <TopNav />
        <TopTabs />

        <section style={{ marginBottom: "1.1rem" }}>
          <a href="/category/allproducts">
            <img
              style={{ width: "100%", height: "auto" }}
              src="https://cdn.shopify.com/s/files/1/0575/5404/2927/files/aadioffer.jpg?v=1752212988"
              alt="Aadi Sale 2025"
            />
          </a>
        </section>

        <div
          className="d-flex align-items-center justify-content-center"
          id="topBanner"
        >
          <div className="bgcolor">
            <div className="text-center">
              <h1 className="text-white text-center">
                Cooking Appliances, Redefined.
                <br />
              </h1>
              <a href="/category/allproducts">
                <button
                  type="button"
                  className="btn btn-outline-light px-5 py-2"
                >
                  Shop Now
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <DetailOne />
        </div>

        <div ref={ref1} id="product">
          <CollectionTabs />
        </div>

        <div id="recentpostsx">
          <RecentBlog />
        </div>

        <div id="testimonials">
          <Testimonials />
        </div>

        {/* <div id='detail_1'>
          <div className='row pb-5 pt-3'>

            <div className='col-sm-12 col-12 pb-sm-0 pb-4'>
              <h4 className='text-center py-3 main--title'>Genesis of VB DACE</h4>
            </div>

            <div className='d-sm-flex justify-content-sm-center text-center'>
              <div className='col-sm-9 col-12 mx-auto' style={{ padding: '0px 2rem' }}>
                VB DACE was born out his ardent desire to share with his followers, the same ecstasy,
                he gets while cooking in his premium range of carefully researched and curated cookware
                and make it accessible to his fellowmen.
                <br />
                "Knowledge is power. Knowledge shared is power multiplied".
              </div>
            </div>
          </div>
        </div> */}

        {/* <Slider /> */}
        {/* <ImgBlocks play={play} setPlay={(data) => setPlay(data)} /> */}
        <ServiceBlock />
        {/* <PressBlock /> */}
        <FooterBlock />
      </div>
    </div>
  );
};

// export default index
// class Home extends Component {
//   state = {
//     slideData: (type) => temp.slideData[type],
//     categories: [],
//     myRef: React.createRef()
//   };

//   executeScroll = () => this.myRef.current.scrollIntoView()
//   render() {
//     return (
//       <div id="home">
//         <TopNav />
//         <TopTabs
//           slideData={this.state.slideData("shopifyData")}
//           {...this.props}
//         />
//         <div className='d-flex align-items-center justify-content-center' id="topBanner">
//           <div className='text-center'>
//             <h1 className='text-white text-center'>
//               Fall in Love with Your Kitchen
//             </h1>
//             <button type="button" className="btn btn-outline-light px-5 py-2" onClick={this.executeScroll}>Shop Now</button>
//           </div>
//         </div>
//         <DetailOne />
//         <Slider />
//         <ImgBlocks slideData={this.state.slideData("imgBlock")} />
//         <MultipleTabs ref={(ref) => this.state.myRef = ref} />
//         <ServiceBlock />
//         <PressBlock slideData={this.state.slideData("pressBlock")} />
//         <FooterBlock />
//       </div>
//     );
//   }
// }
const mapStateToProps = (state) => ({
  Loading: state.task.loading,
  categories: state.task.categories,
});

const mapDispacthToProps = (dispatch) => {
  return {
    GetCategories: () => dispatch(GetCategories()),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(Home);
